import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../axios';
import { Card, PageHeader, Button } from '../UI';
import classes from './AddProject.module.css';

const AddProject = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    location: '',
    notes: '',
    status: 'Preparation'
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validate = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'Project name is required';
    } else if (formData.name.trim().length < 2) {
      newErrors.name = 'Project name must be at least 2 characters';
    }
    
    if (!formData.location.trim()) {
      newErrors.location = 'Location is required';
    }
    
    if (!formData.status) {
      newErrors.status = 'Status is required';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validate()) {
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post('/projects', {
        name: formData.name.trim(),
        location: formData.location.trim(),
        notes: formData.notes.trim(),
        status: formData.status
      });

      if (response.data && response.data.success) {
        navigate('/projects');
      } else {
        alert(response.data?.message || 'Failed to create project');
      }
    } catch (error) {
      console.error('Failed to create project:', error);
      const errorMessage = error.response?.data?.message || 'Failed to create project';
      alert(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.addProject}>
      <PageHeader title="Add project" backUrl="/projects" />
      
      <div className={classes.formContainer}>
        <Card padding="large">
          <form onSubmit={handleSubmit} className={classes.form}>
          <div className={classes.formGroup}>
            <label className={classes.label}>
              Project name <span className={classes.required}>*</span>
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className={`${classes.input} ${errors.name ? classes.inputError : ''}`}
              placeholder="Enter project name"
            />
            {errors.name && (
              <div className={classes.errorMessage}>{errors.name}</div>
            )}
          </div>

          <div className={classes.formGroup}>
            <label className={classes.label}>
              Location <span className={classes.required}>*</span>
            </label>
            <input
              type="text"
              name="location"
              value={formData.location}
              onChange={handleChange}
              className={`${classes.input} ${errors.location ? classes.inputError : ''}`}
              placeholder="Enter location"
            />
            {errors.location && (
              <div className={classes.errorMessage}>{errors.location}</div>
            )}
          </div>

          <div className={classes.formGroup}>
            <label className={classes.label}>Notes</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              className={classes.textarea}
              placeholder="Add notes about this project..."
              rows={6}
            />
          </div>

          <div className={classes.formGroup}>
            <label className={classes.label}>
              Status <span className={classes.required}>*</span>
            </label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              className={`${classes.select} ${errors.status ? classes.inputError : ''}`}
            >
              <option value="Preparation">Preparation</option>
              <option value="In progress">In progress</option>
              <option value="Delivered">Delivered</option>
            </select>
            {errors.status && (
              <div className={classes.errorMessage}>{errors.status}</div>
            )}
          </div>

          <div className={classes.buttonsRow}>
            <Button
              type="button"
              variant="secondary"
              onClick={() => navigate('/projects')}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="primary"
              disabled={loading}
            >
              {loading ? 'Creating...' : 'Create Project'}
            </Button>
          </div>
          </form>
        </Card>
      </div>
    </div>
  );
};

export default AddProject;

